<template>
    <el-dialog
        class="detail-currency"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="detail Currency"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="detailForm"
                :model="detailForm"
                :rules="rules"
                label-width="70px"
                disabled
            >
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="Name" prop="name" size="small">
                            <el-input
                                v-model="detailForm.name"
                                placeholder="Please input name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Code" prop="code" size="small">
                            <el-input
                                v-model="detailForm.code"
                                placeholder="Please input code"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="Symbol" prop="symbol" size="small">
                            <el-input
                                v-model="detailForm.symbol"
                                placeholder="Please input symbol"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { cmofferApi } from "@/http/cmofferApi.js";
export default {
    data() {
        return {
            detailForm: {
                name: "",
                code: "",
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: "Please input name",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "Please input code",
                    },
                ],
                symbol: [
                    {
                        required: true,
                        message: "Please input symbol",
                    },
                ],
            },
        };
    },
    methods: {
        closeDialog() {
            this.detailForm = {
                name: "",
                code: "",
            };
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        currencyList() {
            cmofferApi
                .currencyList(
                    {
                    },
                    "get",
                    this.tableItem.id
                )
                .then((res) => {
                    if (res) {
                      this.detailForm = { ...res.data };
                    }
                });
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        funcName: String,
    },
    watch: {
        detailVisible(val) {
          this.currencyList();
        },
    },
};
</script>
<style lang="scss" scoped>
.detail-currency {
    .container {
    }
}
</style>
